var React = require('react');

function RealEstateInline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M97.498 111.414c-22.485 0-40.715-18.228-40.715-40.713 0-22.486 18.23-40.714 40.715-40.714 22.487 0 40.715 18.228 40.715 40.714 0 22.485-18.228 40.713-40.715 40.713Zm0-101.414c-33.328 0-60.44 27.113-60.44 60.44 0 32.547 55.863 91.377 58.24 93.867a3.042 3.042 0 0 0 4.4 0c2.379-2.489 58.243-61.32 58.243-93.867 0-33.327-27.115-60.44-60.443-60.44","clipRule":"evenodd","key":0}),React.createElement("path",{"d":"M76 69v22h14.054v-7.603c0-4.213 3.334-7.628 7.446-7.628 4.113 0 7.447 3.415 7.447 7.627V91H119V69L97.5 47 76 69Z","clipRule":"evenodd","key":1})]);
}

RealEstateInline.defaultProps = {"className":"fill-current","viewBox":"0 0 200 176"};

module.exports = RealEstateInline;

RealEstateInline.default = RealEstateInline;
